'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _appBadges = require('../../../atoms/app-badges');

var _appBadges2 = _interopRequireDefault(_appBadges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'editorial';

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    var fontSize = headline.headlineSize || null;
    var fontClass = (0, _classnames2.default)('editorial__headline', fontSize);
    return _react2.default.createElement(
      _heading2.default,
      { level: '2', className: fontClass },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: 'editorial__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: 'editorial__hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var renderBadge = function renderBadge(content, clientInfo) {
  var appBadgeContent = {
    clientInfo: clientInfo,
    ios: content.ios,
    android: content.android
  };
  var classes = ORGANISM_NAME + '__app-badge-wrapper';

  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(_appBadges2.default, appBadgeContent)
  );
};

var renderContentSection = function renderContentSection(content, clientInfo) {
  var headline = content.headline,
      paragraph = content.paragraph,
      hatchText = content.hatchText;


  return _react2.default.createElement(
    'div',
    {
      className: 'col-xs-12 col-md-6 editorial__container editorial__text text-xs-center text-md-left'
    },
    renderHeadline(headline),
    renderParagraph(paragraph),
    renderBadge(content, clientInfo),
    renderHatchText(hatchText)
  );
};

var Editorial = function (_React$Component) {
  _inherits(Editorial, _React$Component);

  function Editorial(props) {
    _classCallCheck(this, Editorial);

    var _this = _possibleConstructorReturn(this, (Editorial.__proto__ || Object.getPrototypeOf(Editorial)).call(this, props));

    _this.handleScroll = _this.handleScroll.bind(_this);
    // adding references in case this component is extended
    _this.renderHeadline = renderHeadline;
    _this.renderParagraph = renderParagraph;
    _this.renderHatchText = renderHatchText;
    _this.renderContentSection = renderContentSection;
    _this.state = {
      showImages: false
    };
    return _this;
  }

  _createClass(Editorial, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'renderImage',
    value: function renderImage(image) {
      if (this.state.showImages && image && image.src) {
        return _react2.default.createElement('img', { className: 'editorial__image', src: image.src, alt: image.alt || null });
      }
      return null;
    }
  }, {
    key: 'renderImageSection',
    value: function renderImageSection(deviceImage) {
      return _react2.default.createElement(
        'div',
        {
          className: 'col-md-6 hidden-sm-down text-xs-center editorial__container editorial__device-image'
        },
        this.renderImage(deviceImage)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          config = _props.config,
          content = _props.content,
          className = _props.className,
          clientInfo = _props.clientInfo;
      var id = config.id,
          theme = config.theme,
          textPosition = config.textPosition,
          backgroundImage = config.backgroundImage,
          backgroundPosition = config.backgroundPosition;
      var deviceImage = content.deviceImage;


      var editorialClasses = (0, _classnames2.default)('editorial', theme, className);

      var backgroundImageStyle = this.state.showImages && backgroundImage && backgroundImage.url ? {
        backgroundImage: 'url(' + backgroundImage.url + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: editorialClasses,
          'data-building-block': 'organism',
          style: backgroundImageStyle,
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          textPosition === 'right' ? _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderImageSection(deviceImage),
            renderContentSection(content, clientInfo)
          ) : _react2.default.createElement(
            'div',
            { className: 'row' },
            renderContentSection(content, clientInfo),
            this.renderImageSection(deviceImage)
          )
        )
      );
    }
  }]);

  return Editorial;
}(_react2.default.Component);

exports.default = Editorial;


Editorial.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light', 'theme-background-image-dark', 'theme-background-image-light']).isRequired,
    textPosition: _propTypes2.default.oneOf(['left', 'right']),
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired
    }),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    deviceImage: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string,
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string,
    client_is_mobile: _propTypes2.default.bool,
    client_type: _propTypes2.default.string
  })
};

Editorial.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-image-dark',
    textPosition: 'left',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/de/de/passport/home/01_Home_Hero.jpg'
    },
    backgroundPosition: 'center'
  },
  content: {
    headline: {
      text: '36 characters maximum or 2 lines.'
    },
    paragraph: {
      text: '120 characters maximum per line for paragraphs, ' + 'using text blocks equal in height to optional device images.'
    },
    deviceImage: {
      src: 'https://www.paypalobjects.com/webstatic/en_US/mktg/wright/mobile-apps/narr_sendmoney_enus_1x.png',
      alt: 'Text should describe the "device image" example.'
    },
    hatchText: {
      text: '34 characters maximum per line'
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy',
      fpti: 'editorial'
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh',
      fpti: 'editorial'
    }
  },
  className: '',
  clientInfo: {
    client_os_type: 'ios',
    client_is_mobile: true,
    client_type: 'dedicated'
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/editorial/jsx/Editorial.js
// module id = 675
// module chunks = 4